const { createSlice } = require("@reduxjs/toolkit");

const AddonSlice = createSlice({
    name: "addons",
    initialState: {
        selectedAddon: []
    },
    reducers: {
        add_Addons: (state, action) => {
            const addOns = action.payload
            // console.log("addOnds",addOns)
            // console.log("addOndsID",addOns.id)
            const Exsisting = state?.selectedAddon.find((addon) => addon?.addOn.id === addOns?.id)

            if (Exsisting) {
                Exsisting.quantity += 1
            }
            else {
                state.selectedAddon.push({ addOn: addOns, quantity: 1 })
            }
        },
        removeAddon: (state, action) => {
            const { addOnId } = action.payload
            state.selectedAddon = state.selectedAddon.filter((addon) => addon?.id == addOnId)
        },
        updateAddOnCount: (state, action) => {
            const addOns = action.payload;
            console.log("addOnId", addOns?.id);
            // Check if there are existing addons with the same id
            const existingAddonIndex = state.selectedAddon.findIndex((addon) => addon.addOn.id === addOns.id);

            if (existingAddonIndex !== -1) {
                // If the addon exists, decrement its quantity
                state.selectedAddon[existingAddonIndex].quantity -= 1;

                // Optionally, you can remove the addon if its quantity becomes zero
                if (state.selectedAddon[existingAddonIndex].quantity === 0) {
                    state.selectedAddon.splice(existingAddonIndex, 1);
                }

                // Update the state (if necessary, depending on your context)
                // For example, if using React with useState:
                // setState({ ...state, selectedAddon: state.selectedAddon });
            }
        }

    }
})


export const { add_Addons, removeAddon, updateAddOnCount } = AddonSlice.actions

export default AddonSlice.reducer  